import React from 'react';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { PAGES } from '../constants/pages';
import {
  FormContainer,
  FormWrap,
} from '../components/FormContainer/FormContainer';
import BaseLayout from '../components/BaseLayout';
import ForgotPasswordCard from '../components/ForgotPassword/ForgotPasswordCard';
import BaseLayoutCta from '../components/BaseLayoutCta/BaseLayoutCta';
import PasswordInput from '../components/Fields/PasswordInput';
import { getValidationSchema } from '../util/helpers/getValidationSchema';
import { retrieveFromSessionStorage } from '../util/helpers/sessionStorageHelper';
import { EMAIL } from '../constants/sessionStorage';
import { salesAssistedSetPassword } from '../store/actions/salesAssisted/salesAsssistedActions';
import { authenticateUser } from '../store/actions/user/userActions';
import useTrackingDetails from '../hooks/useTrackingDetails';
import InputText from '../components/Fields/InputText';

const SetPasswordPage = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const email = retrieveFromSessionStorage(EMAIL);
  const { TrackingDetails } = useTrackingDetails();

  const formValidationSchema = yup.object({
    ...getValidationSchema({
      fields: ['Password'],
    }),
  });

  const { handleSubmit, setError, control } = useForm({
    defaultValues: { Password: '' },
    resolver: yupResolver(formValidationSchema),
  });

  const onSubmit = (data) => {
    const payload = {
      Email: email,
      Password: data.Password,
    };
    dispatch(
      salesAssistedSetPassword({
        data: { ...payload },
        handleSuccess: () => {
          dispatch(
            authenticateUser({
              data: {
                EMAIL: email,
                Password: data.Password,
                TrackingDetails,
              },
              onSuccess: () => history.push(PAGES.LOADING),
            }),
          );
        },
        handleError: (errorMsg) => {
          setError('Password', {
            type: 'manual',
            message: errorMsg,
          });
        },
      }),
    );
  };

  return (
    <BaseLayout noLogoBox>
      <ForgotPasswordCard
        title={t('setPassword.title')}
        subtitle={t('setPassword.newPassword.subtitle')}
      >
        <FormWrap>
          <FormContainer>
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field, fieldState }) => (
                <InputText
                  label={t('loginFluent.emailAddress')}
                  type="email"
                  {...field}
                  {...fieldState}
                  autoFocus
                  autocomplete="email username"
                  value={email}
                  disabled
                />
              )}
              name="Email"
              defaultValue=""
            />
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field, fieldState }) => (
                <PasswordInput
                  label={t('loginFluent.password')}
                  {...field}
                  {...fieldState}
                  autocomplete="new-password"
                />
              )}
              name="Password"
              defaultValue=""
            />
          </FormContainer>
          <BaseLayoutCta
            buttonProps={{
              type: 'submit',
              title: t('setPassword.newPassword.savePassword'),
              onClick: handleSubmit(onSubmit),
            }}
            fullWidth
          />
        </FormWrap>
      </ForgotPasswordCard>
    </BaseLayout>
  );
};

export default SetPasswordPage;
